import { isRouteActive } from 'router/declarative/filterRouteActive';
import type { AppRoute, AppRouterLocation } from 'router/declarative/location$';
import { AppModules } from '../types';

const PRESENTATION_FREE_ROUTES: Partial<Record<AppModules, AppRoute>> = {
  [AppModules.DASHBOARDS]: '/dashboard/builder',
  [AppModules.REPORTS]: '/report/builder',
};

type PresentationPage = {
  selectedModule: AppModules;
  location: AppRouterLocation;
};

export const isPresentationSupportedOnPage = ({
  selectedModule,
  location,
}: PresentationPage): boolean => {
  const route = PRESENTATION_FREE_ROUTES[selectedModule];
  return route === undefined || !isRouteActive(location, route);
};
